module.exports = __webpack_public_path__ + "static/media/dungeondoor.5e40bcf6.mp3";